import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid,
  TextField
} from "@mui/material";
import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import {
  IRoleMain,
  MasterPages
} from "../../../commonFunctions/CommonFunctions";
import { getPermissions } from "../../../commonFunctions/PermissionManger";
import WSButton from "../../../Components/Button/WSButton";

import WSDataGridForDashboard, {
  IColumns
} from "../../../Components/DataGrid/WSDataGridForDashboard";
import { useSnackbar } from "../../../Components/Snackbar/SnackBarContext";
import http from "../../../commonFunctions/htttpClientNew";
import config from "../../../Config/config.json";
import { resetDataComponent } from "../../../StateManagement/actions";
import { IRows } from "../../../Components/Filter/WSFilterComponent";

export const ChequeIssueList: React.FC<any> = React.memo((props) => {
  const navigate = useNavigate();
  const { edit } = getPermissions(MasterPages.Users, IRoleMain.Masters);
  const [selectedIds, setSelectedIds] = useState<number[]>([]);

  const [dueDate, setDueDate] = useState("");
  const [category, setCategory] = useState("");
  const [invoiceNo, setInvoiceNo] = useState("");
  const [isHold, setisHold] = useState(false);
  const [chequeIssued, setChequeIssued] = useState(false);
  const [amount, setAmount] = useState(0);
  const [invDate, setInvDate] = useState("");
  const [supplierId, setSupplierId] = useState("");

  const [id, setId] = useState(null);
  const [openEditModal, setOpenEditModal] = useState(false);

  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();
  const { showMessage } = useSnackbar();

  const source = {
    url: "Bill/search",
    page: 1,
    pageSize: 10,
    filter: [
      {
        field: "ChequeIssued",
        operator: "eq",
        value: "true"
      }
    ],
    sort: []
  };

  const handleAction = (action: string, row: any) => {
    if (action === "Edit") {
      console.log("row is ", row);
      setId(row?.id);
      setOpenEditModal(true);

      setCategory(row?.category || "");
      setInvoiceNo(row?.invoiceNo || "");
      setChequeIssued(row?.chequeIssued || false);
      setisHold(row?.isHold || false);
      setAmount(row?.amount || 0);
      setInvDate(row?.invoiceDate?.split("T")[0] || "");
      setDueDate(row?.dueDate?.split("T")[0] || "");
      setSupplierId(row?.supplierId || row?.supplier?.id || "");
    }
  };

  const columns: IColumns[] = [
    { header: "Supplier Name", fieldName: "name", type: "default" },
    { header: "Invoice No", fieldName: "invoiceNo", type: "default" },
    {
      header: "Amount",
      fieldName: "amount",
      type: "currency"
    },
    { header: "Invoice Date", fieldName: "invoiceDate", type: "date" },
    { header: "Due Date", fieldName: "dueDate", type: "date" },
    { header: "Category", fieldName: "category", type: "default" },
    {
      header: "Actions",
      fieldName: "actions",
      type: "action",
      actions: [edit ? "Edit" : undefined],
      actionCallback: (action, row) => handleAction(action, row)
    }
  ];

  const transFormData = (data: any[]) => {
    if (!data) return [];
    data.forEach((item) => {
      item.name = item?.supplier?.name;
    });
    return data;
  };

  const handleSelectionChange = (response: any[]) => {
    if (Array.isArray(response) && response.length > 0) {
      const ids = response.map((item) => item.id);
      setSelectedIds(ids);
    } else {
      setSelectedIds([]);
    }
  };

  const handleSaveClick = async () => {
    try {
      if (selectedIds.length > 0) {
        setLoading(true);
        const request = {
          id: selectedIds
        };
        const response: any = await http.post(
          config.apiDashboardBaseUrl + "Bill/bulk-issue-cheques",
          request
        );
        if (response && response.message) {
          setLoading(false);
          dispatch(resetDataComponent("checkIssueList"));
          showMessage(response.message, "success");
        }
      }
    } catch (e) {
      console.error("Error in saving:", e);
    } finally {
      setLoading(false);
    }
  };

  const handleUpdate = async () => {
    try {
      const request = {
        dueDate: dueDate,
        category: category,
        invoiceNo: invoiceNo,
        supplierId: supplierId,
        invDate: invDate,
        amount: amount,
        chequeIssued: chequeIssued,
        isHold: isHold
      };
      const response: any = await http.put(`/Bill/${id}`, request);
      console.log("response looks due date", response);

      if (response?.message) {
        dispatch(resetDataComponent("checkIssueList"));
        showMessage(response.message, "success");
        setOpenEditModal(false);
      }
    } catch (e) {
      console.error("Error in saving:", e);
    } finally {
      setLoading(false);
    }
  };

  const handleCancelClick = () => {
    setSelectedIds([]);
    navigate("/home");
  };
  const filterRows: IRows[] = [
    {
      label: "Due Date",
      fieldName: "DueDate",
      type: "date",
      operator: "eq"
    }
  ];
  return (
    <>
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <WSDataGridForDashboard
            id="checkIssueList"
            title="Check Issued"
            pageSize={10}
            searchBox={{ fieldName: "Category,InvoiceNo,Supplier.Name" }}
            filterFields={filterRows}
            columns={columns}
            multiSelect={true}
            onSelectionChange={handleSelectionChange}
            source={source}
            transFormData={transFormData}
            gridHeaderSx={{
              backgroundColor: "whitesmoke",
              border: "1px solid whitesmoke"
            }}
          />
        </Grid>

        {/* Button Section */}
        <Grid
          item
          xs={12}
          sx={{
            marginTop: "3rem",
            display: "flex",
            justifyContent: "flex-end",
            gap: 2
          }}
        >
          <WSButton
            id="submit"
            label="Save"
            type="button"
            className={`ws-default ${
              selectedIds.length === 0 ? "disabled" : ""
            }`}
            disabled={selectedIds.length === 0}
            size="medium"
            loading={loading}
            onClick={handleSaveClick}
          />
          <WSButton
            id="cancel"
            label="Cancel"
            type="button"
            onClick={handleCancelClick}
            size="medium"
            className="ws-cancel"
          />
        </Grid>

        <Dialog
          open={openEditModal}
          onClose={() => setOpenEditModal(false)}
          maxWidth="sm"
          fullWidth
          PaperProps={{
            sx: {
              borderRadius: 3,
              boxShadow: "0 8px 30px rgba(0,0,0,0.1)",
              p: 2
            }
          }}
        >
          <DialogTitle
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              fontWeight: 600,
              fontSize: "1.25rem",
              color: "#3D52A0",
              pb: 0
            }}
          >
            Edit Due Date
          </DialogTitle>

          <DialogContent sx={{ mt: 1 }}>
            <TextField
              fullWidth
              margin="normal"
              label="Due Date"
              name="dueDate"
              type="date"
              value={dueDate}
              onChange={(e) => setDueDate(e.target.value)}
              InputLabelProps={{ shrink: true }}
              sx={{
                "& input": {
                  padding: "10px 14px"
                },
                "& fieldset": {
                  borderRadius: "10px"
                }
              }}
            />
          </DialogContent>

          <DialogActions sx={{ px: 3, pb: 2 }}>
            <Button
              onClick={() => setOpenEditModal(false)}
              variant="outlined"
              color="inherit"
              sx={{
                textTransform: "none",
                borderRadius: "10px",
                px: 3
              }}
            >
              Cancel
            </Button>
            <Button
              variant="contained"
              onClick={handleUpdate}
              sx={{
                backgroundColor: "#3D52A0",
                textTransform: "none",
                borderRadius: "10px",
                px: 3,
                "&:hover": {
                  backgroundColor: "#2f4085"
                }
              }}
            >
              Save
            </Button>
          </DialogActions>
        </Dialog>
      </Grid>
    </>
  );
});
